import MapLeftContainer from "../../../components/property/map/MapLeft";

const MapLeft = () => {
  return <MapLeftContainer />;
};

export default MapLeft;
